import { render } from "./menuDesignView.vue?vue&type=template&id=3e4512da&scoped=true"
import script from "./menuDesignView.vue?vue&type=script&lang=js"
export * from "./menuDesignView.vue?vue&type=script&lang=js"

import "./menuDesignView.vue?vue&type=style&index=0&id=3e4512da&scoped=true&lang=css"

import exportComponent from "/var/www/shortcodeMarket/clientdashboard/dashboard/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3e4512da"]])

export default __exports__